import React, { useEffect, useState } from "react";
import Carousel from "../components/home/Carousel";
import Manager from "../components/home/Manager";
import Rooms from "../components/home/Rooms";
import Info from "../components/home/Info";
// import Offers from "../components/home/Offers";
import Tesimonial from "../components/home/Tesimonial";
import {
  fetchCraftsmanshipSlider,
  fetchHighlightsTitle,
  fetchHomeSliders,
  fetchManagerMessage,
  fetchMissionVision,
  fetchOffers,
  fetchReviewTitle,
  fetchTestimonials,
} from "../api/HomeApi";
import {
  ICraftsmanshipSlider,
  IHighlightsTitle,
  IMissionVision,
  IReviewTitle,
  // IOffersData,
  ISliderData,
  ITestimonialData,
} from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { useManagerContext } from "../context/HomeContext";
import { useLoader } from "../context/LoaderContext";
import { fetchRoomData } from "../api/RoomsApi";
import { useRoomContext } from "../context/RoomContext";

const Home: React.FC = () => {
  const { setLoading } = useLoader();
  const [sliderData, setSliderData] = useState<ISliderData[]>([]);
  const { setManagerData } = useManagerContext();
  const [missionVisionData, setMissionVisionData] = useState<IMissionVision[]>(
    [],
  );
  const [higlightsTitle, setHighlightsTitle] = useState<IHighlightsTitle[]>([]);
  const [reviewTitle, setReviewTitle] = useState<IReviewTitle[]>([]);
  const [craftsmanshipSlider, setCraftsmanshipSlider] = useState<
    ICraftsmanshipSlider[]
  >([]);
  // const [offers, setOffers] = useState<IOffersData[]>([]);
  const [testimonial, setTestimonial] = useState<ITestimonialData[]>([]);
  const { setRoomData } = useRoomContext();

  useEffect(() => {
    Promise.all([
      fetchHomeSliders(),
      fetchMissionVision(),
      fetchCraftsmanshipSlider(),
      fetchTestimonials(),
      fetchOffers(),
      fetchHighlightsTitle(),
      fetchReviewTitle(),
    ])
      .then(
        ([
          homeSliderData,
          missionVisionData,
          craftsmanshipSliderData,
          TestimonialData,
          OffersData,
          highlightsTitleData,
          reviewTitleData,
        ]) => {
          setSliderData(homeSliderData);
          setMissionVisionData(missionVisionData);
          setCraftsmanshipSlider(craftsmanshipSliderData);
          setTestimonial(TestimonialData);
          // setOffers(OffersData);
          setHighlightsTitle(highlightsTitleData);
          setReviewTitle(reviewTitleData);
          setLoading(false);
        },
      )
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  useEffect(() => {
    Promise.all([fetchManagerMessage(), fetchRoomData()])
      .then(([ManagerData, RoomData]) => {
        setManagerData(ManagerData);
        setRoomData(RoomData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      });
  }, [setManagerData, setRoomData]);

  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662 no-scroll"
      >
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            <div className="inner_wrapper">
              <div className="sidebar_content full_width">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="662"
                  className="elementor elementor-662"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <Carousel sliderData={sliderData} />
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-65db93bf elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                        data-id="65db93bf"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                      >
                        <div
                          style={{
                            maxWidth: "100%",
                            boxShadow: "0 12px 30px rgba(0, 0, 0, 0.12)",
                            background: "#fff",
                            padding: "8px",
                          }}
                        >
                          <iframe
                            src="https://ibe.channex.io/hoteldachi"
                            title="Hotel Dachi Booking"
                            style={{
                              width: "100%",
                              minHeight: "400px",
                              border: "none",
                              display: "block",
                            }}
                            loading="lazy"
                          />
                        </div>
                      </section>
                      {/* <div id="block-search">
                        <div id="be-search-form" className="be-container">
                          <a
                            href="https://exely.com/"
                            rel="nofollow noreferrer"
                            target="_blank"
                          >
                            Loading...
                          </a>
                        </div>
                      </div> */}

                      <Manager />
                      <Rooms />
                      <Info
                        missionVisionData={missionVisionData}
                        craftsmanshipSlider={craftsmanshipSlider}
                        highlightsTitle={higlightsTitle}
                      />
                      {/* <Offers offers={offers}/> */}
                      <Tesimonial
                        testimonial={testimonial}
                        reviewTitle={reviewTitle}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br className="clear" />
        </div>
      </body>
    </>
  );
};

export default Home;
